import axios from "axios";
const BASE_URL = process.env.REACT_APP_SERVER_DOMAIN;

export default axios.create({
  validateStatus: function (status) {
    return status < 500; // Resuelve solo si el código de estado es menor que 500
  },
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
